import { render } from "./building_put.vue?vue&type=template&id=5b5c1e54"
import script from "./building_put.vue?vue&type=script&lang=js"
export * from "./building_put.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__